import React, { Component, Fragment } from 'react'
import classNames from 'classnames'
import Popover from 'react-popover'
import copy from 'copy-to-clipboard'

import Delete from 'app/components/SVGS/Delete'
import Spinner from 'app/components/Spinner/Spinner'
import './styles.scss'
import Button from 'app/components/ButtonDefault/ButtonDefault'
import InfoPopover from 'app/components/InfoPopover'
import { ACTIVITY_IMAGE } from 'app/constants/gallery'
import IconButton from 'app/domains/common/IconButton'
import Clone from 'app/components/SVGS/Clone'
import { showSuccess } from 'store/entities/toastr/utils'

const bc = 'gallery-item'

class GalleryItem extends Component {
  state = {
    loading: true,
    width: null,
    height: null,
    isShowPopover: false,
  }

  timer = null

  onMouseEnterHandler = () => {
    this.timer = setTimeout(() => this.setState({ isShowPopover: true }), 1000)
  }
  onMouseLeaveHandler = () => {
    clearTimeout(this.timer)
    this.timer = null
    this.setState({ isShowPopover: false })
  }
  render() {
    const {
      t,
      image,
      onItemClick,
      currentImage,
      minImageWidth,
      minImageHeight,
      caption,
      setImageToDelete,
      innerModifier,
      isSuperAdmin,
    } = this.props
    const { loading, width, height } = this.state
    const { url, usagePlaces, fileName } = image
    const selected = url === currentImage
    const isVideo = caption
    const text =
      usagePlaces && usagePlaces !== ''
        ? usagePlaces
            .replace(new RegExp('______', 'g'), '<br/><b>')
            .replace(new RegExp('___', 'g'), '</b>')
            .replace(new RegExp('__', 'g'), '<br/>')
        : t('admin:This image is not used')
    return (
      <div
        className={classNames(bc, {
          [`${bc}--selected`]: selected,
          [`${bc}--hidden`]: width < minImageWidth && height < minImageHeight,
          [`${bc}__video`]: isVideo,
        })}
        onClick={() => !loading && onItemClick(image, width, height)}
        onMouseEnter={this.onMouseEnterHandler}
        onMouseLeave={this.onMouseLeaveHandler}
      >
        {innerModifier === ACTIVITY_IMAGE ? (
          <Popover
            className={`${bc}__popover`}
            isOpen={this.state.isShowPopover}
            preferPlace={null}
            place="above"
            tipSize={7}
            body={
              <InfoPopover
                className={`${bc}__popup`}
                title={t('admin:Usage places')}
                dangerouslyText={{ __html: text }}
              />
            }
          >
            <Fragment>
              <img
                src={url}
                onLoad={({ target: img }) =>
                  this.setState({
                    loading: false,
                    width: img.naturalWidth,
                    height: img.naturalHeight,
                  })
                }
                className={classNames(`${bc}__image`, {
                  [`${bc}__image--visible`]: !loading,
                })}
              />
              {isSuperAdmin && (
                <Button
                  className="btn--delete-icon"
                  onClick={event => {
                    event.stopPropagation()
                    setImageToDelete(url)
                  }}
                >
                  <Delete />
                </Button>
              )}
              <IconButton
                className="btn--copy-icon"
                title={t('admin:Copy image name')}
                onClick={event => {
                  event.stopPropagation()
                  copy(fileName)
                  showSuccess({ content: 'admin:Image name copied successfully' })
                }}
              >
                <Clone />
              </IconButton>
              {selected && (
                <div className={`${bc}__selected-icon`}>
                  <div className={`${bc}__selected-icon-mark`} />
                </div>
              )}
              {loading && <Spinner />}
              {width &&
                height && (
                  <div
                    className={classNames(`${bc}__dimensions`, {
                      [`${bc}__dimensions--selected`]: selected,
                      [`${bc}__caption`]: caption,
                    })}
                  >
                    {`${fileName} ${width} x ${height}`}
                  </div>
                )}
            </Fragment>
          </Popover>
        ) : (
          <Fragment>
            {selected && (
              <div className={`${bc}__selected-icon`}>
                <div className={`${bc}__selected-icon-mark`} />
              </div>
            )}
            {loading && <Spinner />}
            <img
              src={url}
              onLoad={({ target: img }) =>
                this.setState({
                  loading: false,
                  width: img.naturalWidth,
                  height: img.naturalHeight,
                })
              }
              className={classNames(`${bc}__image`, {
                [`${bc}__image--visible`]: !loading,
              })}
            />
            {width &&
              height && (
                <div
                  className={classNames(`${bc}__dimensions`, {
                    [`${bc}__dimensions--selected`]: selected,
                    [`${bc}__caption`]: caption,
                  })}
                >
                  {caption || `${width} x ${height}`}
                </div>
              )}
          </Fragment>
        )}
      </div>
    )
  }
}

export default GalleryItem
